export const mockData = {
  company: {
    name: "VALORYX",
    tagline: "Wachstum mit System. Nicht durch Zufall.",
    description: "VALORYX begleitet Unternehmen dabei, Nachfrage, Vertrieb und Wachstum planbar zu strukturieren. Strategisch. Messbar. Nachhaltig.",
    footer_description: "Strategische Wachstums- und Nachfrageberatung",
    contact: {
      name: "Simeon Ezeh",
      email: "info@valoryx.de",
      phone: "+49 30 12345678",
      address: "Charlottenstraße 85, 10969 Berlin"
    }
  },
  hero: {
    badge: "Wachstum mit System",
    title: "Wachstum mit System.",
    titleHighlight: "Nicht durch Zufall.",
    description: "VALORYX begleitet Unternehmen dabei, Nachfrage, Vertrieb und Wachstum planbar zu strukturieren. Strategisch. Messbar. Nachhaltig.",
    features: [
      {
        title: "Nachhaltiges Wachstum",
        subtitle: "Belastbare Strukturen"
      },
      {
        title: "Klare Strategien",
        subtitle: "Die richtigen Hebel"
      },
      {
        title: "Messbare Steuerung",
        subtitle: "Datenbasierte Entscheidungen"
      }
    ]
  },
  services: [
    {
      id: 1,
      title: "Sales & Vertriebsstruktur",
      description: "Planbare Umsätze entstehen durch klare Prozesse.",
      features: [
        "Entwicklung belastbarer Vertriebsstrategien",
        "Strukturierung und Priorisierung der Pipeline",
        "Optimierung von Entscheidungs- und Abschlussprozessen",
        "Transparente Analyse relevanter Kennzahlen"
      ]
    },
    {
      id: 2,
      title: "Nachfrage & Wachstum",
      description: "Sichtbarkeit allein reicht nicht. Entscheidend ist Relevanz.",
      features: [
        "Strategischer Aufbau von Nachfrage",
        "Qualifizierte Lead-Generierung",
        "Optimierung von Kontaktpunkten und Entscheidungswegen",
        "Systematische Nutzung digitaler Kanäle"
      ]
    },
    {
      id: 3,
      title: "Führungskräfte & Schlüsselpositionen",
      description: "Wachstum scheitert selten an Ideen – sondern an Menschen.",
      features: [
        "Executive Search & Direktansprache",
        "Qualitative Vorauswahl und Bewertung",
        "Positionierung als attraktiver Arbeitgeber",
        "Aufbau langfristiger Talent-Pipelines"
      ]
    }
  ],
  benefits: [
    {
      id: 1,
      title: "Planbare Anfragen",
      description: "Keine Abhängigkeit von Zufall oder einzelnen Kanälen"
    },
    {
      id: 2,
      title: "Bessere Abschlussquoten",
      description: "Klare Prozesse statt Reibungsverluste"
    },
    {
      id: 3,
      title: "Kürzere Entscheidungszyklen",
      description: "Struktur reduziert Komplexität"
    },
    {
      id: 4,
      title: "Stabile Marktposition",
      description: "Sichtbarkeit mit Substanz – nicht mit Lautstärke"
    }
  ],
  whatItMeans: [
    {
      id: 1,
      title: "Nachhaltiges Wachstum",
      description: "Keine kurzfristigen Maßnahmen, sondern belastbare Strukturen"
    },
    {
      id: 2,
      title: "Klare Strategien",
      description: "Fokus auf die richtigen Hebel – nicht auf Aktionismus"
    },
    {
      id: 3,
      title: "Messbare Steuerung",
      description: "Entscheidungen auf Basis von Daten, nicht Bauchgefühl"
    },
    {
      id: 4,
      title: "Technologie als Werkzeug",
      description: "Systeme unterstützen den Prozess – sie ersetzen ihn nicht"
    }
  ],
  clientLogos: [
    { id: 1, name: "Client 1", placeholder: true },
    { id: 2, name: "Client 2", placeholder: true },
    { id: 3, name: "Client 3", placeholder: true },
    { id: 4, name: "Client 4", placeholder: true },
    { id: 5, name: "Client 5", placeholder: true },
    { id: 6, name: "Client 6", placeholder: true }
  ]
};